import { ActionState } from '../../../../models/FlipbookV2/TileData/TileDataImage.model';

export const ActionItems = [
  { item: 'Redirect', label: ActionState.URL },
  { item: 'ProductCard', label: ActionState.SKU }
];
